function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg25(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.7 70.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.54,3.36c-.89,1.87-1.61,3.9-1.61,4.52s-1.14,3.91-2.52,7.33c-1.43,3.52-3.4,11.95-4.55,19.48-1.11,7.3-2.67,15.41-3.47,18.02-2.35,7.74-1.97,9.53,3.01,14.12,3.35,3.09,5.3,4.13,7.75,4.12,3.86,0,9.16-2.99,10.83-6.1,1.48-2.77.53-11.87-1.7-16.18-1.32-2.55-1.63-6.99-1.73-24.66-.07-11.85-.49-22.12-.93-22.8-1.42-2.19-3.42-1.35-5.08,2.15",
    style: {
      fill: "#010101",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.29,12.79c-.4,4.76-.7,9.34-.66,10.16.04.83.34,5.78.66,11l.59,9.5h-5.97c-3.29,0-5.98-.03-5.97-.07.02-3.82,3.65-21.98,5.13-25.7,1.14-2.87,2.73-7.37,3.52-10,2.22-7.38,3.55-4.87,2.71,5.12",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.74,45.57c2.42.48,3.41,1.47,4.71,4.73,1.99,4.97,2.14,12.15.31,14.36-.73.88-2.83,2.23-4.65,2.99-3.01,1.26-3.63,1.19-6.65-.67-1.83-1.13-4.07-3.18-4.96-4.55-1.5-2.29-1.5-2.93-.02-8.23,1.56-5.56,4.32-9.25,6.93-9.25.7,0,2.64.28,4.33.61",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg25);
export default __webpack_public_path__ + "static/media/25.c441f6b683d5640796a207a6feabeab4.svg";
export { ForwardRef as ReactComponent };